import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export interface AddContainerDialogProps {
    title?: JSX.Element;
    text?: JSX.Element;
    content?: JSX.Element;
    open?: boolean;
    onClose?: () => void;
    onNo?: () => void;
}

function AddContainerDialog({ title, text, content, open = false, onClose, onNo }: AddContainerDialogProps) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{text}</DialogContentText>
                {content}
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onNo}>
                    <FormattedMessage id="no" />
                </Button>
                <Button variant="contained" onClick={onClose}>
                    <FormattedMessage id="disable" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AddContainerDialog;
